import { deleteCookie as _deleteCookie, setCookie as _setCookie } from '@jwplayer/fe-common/module/cookies';
// We can always be safe to set it on the root path
const COOKIE_PATH = '/';
const COOKIE_ACCEPTED_DOMAINS = ['jwplayer.com', 'longtailvideo.com', 'localhost', 'jwp.io'];
function getCookieDomain() {
    // We only allow setting cookies on known domains, for prd and local development
    const foundDomain = COOKIE_ACCEPTED_DOMAINS.find((domain) => {
        return window.location.hostname.endsWith(domain);
    });
    if (!foundDomain) {
        throw new Error(`Can not set cookie on unknown domain ${window.location.hostname}`);
    }
    return foundDomain;
}
/**
 * Set a cookie with default companion-lib configuration
 */
export function setCookie(key, value, config, 
/**
 * We should remove this after Angular (admin) dashboard has been deprecated.
 *
 * Currently ng sets only the session cookie on the jwplayer.com domain, all the other
 * cookies are asserted automatically by the browser to use the full domain (e.g. dashboard.jwplayer.com)
 *
 * Once we remove this and change the domain, we'll need to clear the existing cookie at `jwplayer.com`
 * before login, so that we don't have two conflicting cookies (on root domain and subdomain).
 */
useDomain = false) {
    if (typeof value === 'undefined') {
        return;
    }
    const foundDomain = getCookieDomain();
    // For localhost, we'll just check whether it's on https or not
    // Our prd domains should always use https and thus secure cookies!
    const useSecureCookie = foundDomain === 'localhost' ? window.location.protocol === 'https:' : true;
    _setCookie(key, value, Object.assign(Object.assign({}, config), { Path: COOKIE_PATH, Domain: useDomain === true ? foundDomain : undefined, SameSite: 'strict', Secure: useSecureCookie }));
}
export function deleteCookie(key, useDomain = false) {
    const foundDomain = getCookieDomain();
    _deleteCookie(key, {
        // We need to make sure that we're deleting the cookies on the same path as where we're setting them
        Path: COOKIE_PATH,
        Domain: useDomain ? foundDomain : undefined,
    });
}
// Re-export from FEC to keep all cookie functionality available from this module
export { getCookie } from '@jwplayer/fe-common/module/cookies';
